const initialState = {
  distanceReportData: {},
  mobileTicketData: {},
  distanceReportDetails: {},
  mobileTicketsDetails: {},
  mobileSettlementDetails: {},
  distanceReportDataSync: false,
  passData: {},
  passDetails: {},
  passSettlementDetails: {},
  distanceUploadSheetError: "",
};
export default initialState;
